import { IconHandbagSimple, Text } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Subscription } from 'typings'
import { Tag } from '../../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
} from '../../../RuleStack'
import { messages } from '../messages'
import { styles } from '../styles'
import {
  formatCycle,
  formatFrequency,
  formatSubscription,
  formatType,
} from '../format'

type Props = {
  config: Subscription | undefined
  onEdit: () => void
  onRemove: () => void
}

export function SubscriptionView(props: Props) {
  const intl = useIntl()

  const { config, onEdit, onRemove } = props

  if (!config) return null

  const { type } = config
  const { cycle, frequency } = config.filter

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconHandbagSimple />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.title}
          values={{
            b: (content: React.ReactNode) => (
              <Text variant="body">{content}</Text>
            ),
          }}
        />
      </RuleDescription>

      <RuleContent>
        <div className={styles.viewContent}>
          <Tag>{formatType(type, intl)}</Tag>
          <Text variant="detail" tone="secondary">
            {formatSubscription(
              [formatFrequency(frequency, intl), formatCycle(cycle, intl)],
              intl
            )}
          </Text>
        </div>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
